import { render, staticRenderFns } from "./ProductivityTunnel.vue?vue&type=template&id=b3fd5a46"
import script from "./ProductivityTunnel.vue?vue&type=script&lang=js"
export * from "./ProductivityTunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports